import axios from 'axios'

var instance = axios.create({
  timeout: 5000,
})
//配置请求头
instance.defaults.headers.get['Content-Type'] =
  'application/json; charset=utf-8'

export function wechatShare({
  title = '埋堆堆', // 分享标题
  desc = 'TVB官方授权内容使用平台', // 分享描述
  link = '', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
  imgUrl = 'http://live-1254361794.file.myqcloud.com/images/202006/11/20200611193303745771_share-img-tiny.png', // 分享图标
}) {
  let shareUrl = encodeURIComponent(window.location.href)
  instance
    .get('https://activity.mddcloud.com.cn/api/jssdk?url=' + shareUrl)
    .then(function(res) {
      if (res.data.code == 200) {
        var _data = res.data.data
        wx.config({
          debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
          appId: _data.appId, // 必填，公众号的唯一标识
          timestamp: _data.timestamp, // 必填，生成签名的时间戳
          nonceStr: _data.noncestr, // 必填，生成签名的随机串
          signature: _data.signature, // 必填，签名，见附录1
          jsApiList: ['updateAppMessageShareData', 'updateTimelineShareData'], // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
		  openTagList: ['wx-open-launch-weapp'], // 可选，需要使用的开放标签列表，例如['wx-open-launch-app']

        })

        wx.ready(() => {
          var commonShareData = {
            title: title, // 分享标题
            desc: desc, // 分享描述
            link: link,
            imgUrl: imgUrl,
            success: () => {
              // 用户确认分享后执行的回调函数
              //   alert('分享初始化成功')
            },
            error() {
              //   alert('分享初始化失败')
            },
            cancel() {
              //   alert('分享取消')
              // 用户取消分享后执行的回调函数
            },
          }
          wx.updateAppMessageShareData(commonShareData)
          wx.updateTimelineShareData(commonShareData)
        })

        wx.error((res) => {
          //   alert(JSON.stringify(res))
          // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
        })
      }
    })
    .catch(function(error) {
      console.log(error, 'wxShareError')
    })
}
